export const isStr = (val: unknown): val is string => typeof val === "string";

export const isNumber = (value: unknown): boolean => {
    return typeof value === "number" && !Number.isNaN(value);
};

export const range = (size: number, startAt: number = 1): number[] => {
    return [...Array(size).keys()].map((i) => i + startAt);
};

export const clamp = (value: number, min?: number, max?: number): number => {
    value = min != null && value < min ? min : value;
    return max != null && value > max ? max : value;
};
